import axios from 'axios'
import {store} from '@/store'
import DataMain from '@/data/dataMain'
import router from '@/router'

const API = {
  async getData (params) {
    if (store.state.server.status) {
      let startParams = {}
      let apiParams = false
      if (store.state.key) {
        startParams = {'api_token': store.state.key}
      }
      return new Promise(function (resolve, reject) {
        if (!params.slug) {
          reject(new Error('no url provided'))
        }
        DataMain.Load()
        if (params.apiParams) {
          apiParams = { ...startParams, ...params.apiParams }
        } else {
          apiParams = startParams
        }
        axios.post(process.env.API_BASE + params.slug, apiParams)
          .then(
            (response) => {
              let {data} = response
              DataMain.Unload()
              resolve(data)
            },
            (error) => {
              API.closeFullPageLoader()
              // API.handleError(error)
              reject(error)
            }
          )
      })
    }
  },

  async setUpdateTime (params) {
    return new Promise(async function (resolve, reject) {
      if (!params.key || !params.updateTimestamp) {
        reject(new Error('missing parameters'))
      }
      let APIParams = {'api_token': store.state.key, 'key': params.key, 'updateTimestamp': params.updateTimestamp}
      axios.post(process.env.API_BASE + 'api/updatedates/setTimestamp', APIParams)
        .then(
          (response) => {
            DataMain.getUpdateDates()
            resolve(response)
          },
          (error) => {
            reject(error)
          }

        )
    })
  },

  async getUpdateDates () {
    return new Promise(function (resolve, reject) {
      if (store.state.key) {
        let params = {'api_token': store.state.key}
        axios.post(process.env.API_BASE + 'api/updatedates', params)
          .then(
            (response) => {
              resolve(response)
            },
            (error) => {
              reject(error)
            }
          )
      }
    })
  },
  async getActivities () {
    return new Promise(async function (resolve, reject) {
      const params = {
        slug: 'api/activities'
      }
      let results = await API.getData(params)
      resolve(results)
    })
  },

  async getMonth (data) {
    return new Promise(async function (resolve, reject) {
      if (!data.month) {
        reject(new Error('no url provided'))
      }
      const params = {
        apiParams: {
          date: data.month
        },
        slug: 'api/activities/month'
      }
      let dataReturned = await API.getData(params)
      resolve(dataReturned)
    })
  },

  logout () {
    let params = {'api_token': store.state.key}
    axios.post(process.env.API_BASE + 'api/logoutall', params)
  },

  sendPasswordReset (email) {
    store.commit('setFullPageLoader', {
      active: true,
      message: 'Preparing email...'
    })
    return new Promise(function (resolve, reject) {
      let params = {'email': email}
      axios.post(process.env.API_BASE + 'api/password/create', params)
        .then(
          (response) => {
            API.closeFullPageLoader()
            resolve(response)
          },
          (error) => {
            API.closeFullPageLoader()
            API.handleError(error)
            reject(error)
          }
        )
    })
  },

  checkPasswordResetToken (token) {
    return new Promise(async function (resolve, reject) {
      const params = {
        apiParams: { 'token': token },
        slug: 'api/password/find'
      }
      let dataReturned = await API.getData(params)
      resolve(dataReturned)
    })
  },

  resetPassword (apiParams) {
    return new Promise(async function (resolve, reject) {
      const params = {
        apiParams: apiParams,
        slug: 'api/password/reset',
        loadingInfo: {
          message: 'Resetting...',
          location: 'fullpage'
        }

      }
      let dataReturned = await API.getData(params)
      resolve(dataReturned)
    })
  },

  handleError (error) {
    if (error.response.status === 401) {
      store.commit('emptyStore', {
        key: null
      })
      console.log('auto logout')
      router.push({ path: '/login' })
      return
    }
    if (error.response.status === 500) {
      store.commit('setAlert', {
        message: 'We\'re having trouble connecting to our data store. Please try again in a few minutes',
        type: 'warning'
      })
      console.log('no network')
      return
    }
    console.log(error.response)
  },

  closeFullPageLoader () {
    store.commit('setFullPageLoader', {
      active: false,
      message: 'Loading...'
    })
  }
}

export default API



// WEBPACK FOOTER //
// ./src/data/api.js